import { useState, useEffect } from 'react';
import { usePortfolio } from '../../context/PortfolioContext';

function DepositModal({ isOpen, onClose, deposit = null }) {
  const { createDeposit, updateDeposit } = usePortfolio();
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T')[0],
    type: 'DEPOSIT',
    broker: '',
    amount_gbp: '',
  });

  useEffect(() => {
    if (deposit) {
      setFormData({
        date: deposit.date || new Date().toISOString().split('T')[0],
        type: deposit.type || 'DEPOSIT',
        broker: deposit.broker || '',
        amount_gbp: deposit.amount_gbp || '',
      });
    } else {
      // Reset form for new deposit
      setFormData({
        date: new Date().toISOString().split('T')[0],
        type: 'DEPOSIT',
        broker: '',
        amount_gbp: '',
      });
    }
  }, [deposit, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      ...formData,
      amount_gbp: Number(formData.amount_gbp),
    };

    const success = deposit 
      ? await updateDeposit(deposit.id, data)
      : await createDeposit(data);

    if (success) {
      onClose();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <span className="modal-title">{deposit ? 'Edit Entry' : 'New Entry'}</span>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-grid">
              <div className="form-group">
                <label>Date</label>
                <input 
                  type="date" 
                  name="date" 
                  value={formData.date} 
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <label>Type</label>
                <select name="type" value={formData.type} onChange={handleChange}>
                  <option value="DEPOSIT">DEPOSIT</option>
                  <option value="WITHDRAWAL">WITHDRAWAL</option>
                </select>
              </div>
            </div>
            
            <div className="form-grid">
              <div className="form-group">
                <label>Broker</label>
                <input 
                  type="text" 
                  name="broker" 
                  value={formData.broker} 
                  onChange={handleChange}
                  placeholder="e.g. IBKR"
                />
              </div>
              <div className="form-group">
                <label>Amount (GBP)</label>
                <input 
                  type="number" 
                  name="amount_gbp" 
                  value={formData.amount_gbp} 
                  onChange={handleChange}
                  step="0.01"
                  placeholder="0.00"
                  required 
                />
              </div>
            </div>
          </div>
          
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              {deposit ? 'Update' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default DepositModal;
